export default {
  methods: {
    attachSinkId(element, sinkId) {
      if (typeof element.sinkId !== 'undefined') {
        let sinkIdSet = element.setSinkId(sinkId)
        .then(() => {
          this.$logger.info(`Success, audio output device attached: ${sinkId}`, { operation: 'device:audio-output-change' });
          return true;
        })
        .catch(error => {
          let errorMessage = error.message;
          if (error.name === 'SecurityError') {
            errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
          }
          this.$logger.error(errorMessage, { operation: 'device:audio-output-change',event_type:5 });
          return false;
        });

        return sinkIdSet;
      } else {
        this.$logger.warn('Browser does not support output device selection.', { operation: 'device:audio-output-change' });
        return false;
      }
    },

    // Check changes on device list to prevent unnecessary handling of false or repeated `devicechange` events
    isDeviceListUnchanged(oldList, newList) {
      const oldListDeviceIds = this.$_(oldList)?.map('deviceId').uniq().sort().value();
      const newListDeviceIds = this.$_(newList)?.map('deviceId').uniq().sort().value();

      this.$logger.debug('Device ID comparison', {
        added: newListDeviceIds?.filter((id) => !oldListDeviceIds.includes(id)),
        removed: oldListDeviceIds?.filter((id) => !newListDeviceIds.includes(id))
      });

      return this.$_.isEqual(oldListDeviceIds, newListDeviceIds);
    }
  }
}
